import { render, staticRenderFns } from "./coin_form.vue?vue&type=template&id=020e74be&"
import script from "./coin_form.vue?vue&type=script&lang=js&"
export * from "./coin_form.vue?vue&type=script&lang=js&"
import style0 from "./coin_form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports